import { requestWithToken } from "../helper/helper";

const fetchGaon = async (
  pageNo,
  pageSize,
  search,
  sort,
  order,
  stateId,
  districtId,
  blockId
) => {
  try {
    const queryParams = [];

    if (pageNo) queryParams.push(`pageNo=${pageNo}`);
    if (pageSize) queryParams.push(`pageSize=${pageSize}`);
    if (search) queryParams.push(`search=${search}`);
    if (sort) queryParams.push(`sort=${sort}`);
    if (order) queryParams.push(`order=${order}`);
    if (stateId) queryParams.push(`stateId=${stateId}`);
    if (districtId) queryParams.push(`districtId=${districtId}`);
    if (blockId) queryParams.push(`blockId=${blockId}`);
    // Join the query parameters
    const queryString =
      queryParams.length > 0 ? `?${queryParams.join("&")}` : "";

    const response = await requestWithToken(
      "GET",
      `/admin/gaonList${queryString}`
    );

    return response.data;
  } catch (err) {
    return err.response.data;
  }
};

const gaonSearch = async (search) => {
  try {
    const queryParams = [];
    if (search) queryParams.push(`search=${search}`);
    // Join the query parameters
    const queryString =
      queryParams.length > 0 ? `?${queryParams.join("&")}` : "";

    const response = await requestWithToken(
      "GET",
      `/gaon/search${queryString}`
    );

    return response.data;
  } catch (err) {
    return err.response.data;
  }
};
// const fetchGaon = async (pageNo, pageSize, search, sort, order, blockId) => {
//   try {
//     const queryParams = [];

//     if (pageNo) queryParams.push(`pageNo=${pageNo}`);
//     if (pageSize) queryParams.push(`pageSize=${pageSize}`);
//     if (search) queryParams.push(`search=${search}`);
//     if (sort) queryParams.push(`sort=${sort}`);
//     if (order) queryParams.push(`order=${order}`);
//     if (blockId) queryParams.push(`blockId=${blockId}`);
//     // Join the query parameters
//     const queryString =
//       queryParams.length > 0 ? `?${queryParams.join("&")}` : "";

//     const response = await requestWithToken(
//       "GET",
//       `/admin/gaonList${queryString}`
//     );

//     return response.data;
//   } catch (err) {
//     return err.response.data;
//   }
// };

const fetchGaonDetails = async (id) => {
  try {
    const response = await requestWithToken("GET", `/admin/gaonDetails/${id}`);

    return response.data;
  } catch (err) {
    return err.response.data;
  }
};

const editGaon = async (id, payload) => {
  try {
    const response = await requestWithToken(
      "PUT",
      `/admin/gaon/${id}`,
      payload
    );

    return response.data;
  } catch (err) {
    return err.response.data;
  }
};

const editEmergencyContacts = async (id, payload) => {
  try {
    const response = await requestWithToken(
      "PUT",
      `/admin/gaon-emergencyContact/${id}`,
      payload
    );

    return response.data;
  } catch (err) {
    return err.response.data;
  }
};

const editNearPlaces = async (id, payload) => {
  try {
    const response = await requestWithToken(
      "PUT",
      `/admin/gaon-nearPlaces/${id}`,
      payload
    );

    return response.data;
  } catch (err) {
    return err.response.data;
  }
};

const addGaonProducts = async (payload) => {
  try {
    const response = await requestWithToken("POST", `/gaonProduct`, payload);
    return response.data;
  } catch (err) {
    return err.response.data;
  }
};

const getGaonProducts = async () => {
  try {
    const response = await requestWithToken("GET", `/gaonProduct/all`);
    return response.data;
  } catch (err) {
    return err.response.data;
  }
};

const getProductsByGaonId = async (id, page, limit) => {
  try {
    const response = await requestWithToken(
      "GET",
      `/gaonProduct/list?gaonId=${id}&pageNo=${page}&pageSize=${limit}`
    );
    return response.data;
  } catch (err) {
    return err.response.data;
  }
};

const deleteGaonProduct = async (id) => {
  try {
    const response = await requestWithToken("DELETE", `/gaonProduct/${id}`);
    return response.data;
  } catch (err) {
    return err.response.data;
  }
};

const getGaonServices = async (id, page, limit) => {
  try {
    const queryParams = [];

    if (page) queryParams.push(`pageNo=${page}`);
    if (limit) queryParams.push(`pageSize=${limit}`);
    if (id) queryParams.push(`gaonId=${id}`);
    // Join the query parameters
    const queryString =
      queryParams.length > 0 ? `?${queryParams.join("&")}` : "";

    const response = await requestWithToken(
      "GET",
      `/gaon/browseService/list${queryString}`
    );

    return response.data;
  } catch (err) {
    return err.response.data;
  }
};

const getGaonServiceById = async (id) => {
  try {
    const response = await requestWithToken(
      "GET",
      `/gaon/browseService/details/${id}`
    );
    return response.data;
  } catch (err) {
    return err.response.data;
  }
};

const addGaonService = async (payload) => {
  try {
    const response = await requestWithToken(
      "POST",
      `/gaon/browseService`,
      payload
    );
    return response.data;
  } catch (err) {
    return err.response.data;
  }
};

const putGaonService = async (id, payload) => {
  try {
    const response = await requestWithToken(
      "PUT",
      `/gaon/browseService/${id}`,
      payload
    );
    return response.data;
  } catch (err) {
    return err.response.data;
  }
};

const removeGaonService = async (id) => {
  try {
    const response = await requestWithToken(
      "DELETE",
      `/gaon/browseService/${id}`
    );
    return response.data;
  } catch (err) {
    return err.response.data;
  }
};

export {
  fetchGaon,
  editGaon,
  fetchGaonDetails,
  gaonSearch,
  editEmergencyContacts,
  editNearPlaces,
  addGaonProducts,
  getGaonProducts,
  getProductsByGaonId,
  deleteGaonProduct,
  getGaonServices,
  getGaonServiceById,
  addGaonService,
  putGaonService,
  removeGaonService,
};
